const readApiUrl = (name: string, value: string | undefined) => {
  if (!value) throw new Error(`${name} is required`)
  if (value.endsWith('/')) throw new Error(`${name} may not end with /`)

  return value
}

/**
 * Our own origin, `<site>/api`. Use it for routes the site serves itself, such
 * as `/api/app-scraper`.
 */
export const getPublicApiUrl = () =>
  readApiUrl('NEXT_PUBLIC_API_URL', process.env.NEXT_PUBLIC_API_URL)

/**
 * The seo-api service, `<seo-api>/api`. A separate deployment that only serves
 * the endpoints moved there for CDN caching in sc-190458: `/api/seo/*` and the
 * translate routes. Anything else answers 404.
 */
export const getSeoApiUrl = () =>
  readApiUrl('NEXT_PUBLIC_SEO_API_URL', process.env.NEXT_PUBLIC_SEO_API_URL)
